import { Close } from '@mui/icons-material';
import {
	Box,
	Button,
	Container,
	Dialog,
	DialogTitle,
	Grid,
	IconButton,
	Modal,
	useTheme
} from '@mui/material';
import { ImageUploader, TextInput, VideoUploader } from 'components';
import { isEmpty } from 'lodash';

const VideoModal = ({
	open,
	onClose,
	handleChange,
	eventVideo,
	handleDelete,
	handleUploadFile,
	memoryFile,
	setEventVideo,
	submit
}) => {
	const theme = useTheme();

	const handleVideoSelect = (video) => {
		const maxSize = 350 * 1024 * 1024;
		if (video && video.size > maxSize) {
			showAlertError('For large size video, use cloudinary url');
			return;
		}
		setEventVideo((prev) => ({ ...prev, cloudinary_url: '' }));
		handleUploadFile(video, 'video_url');
	};

	return (
		<Dialog open={open} onClose={onClose} sx={{ flex: 1 }}>
			<Box
				sx={{
					backgroundColor: '#fff',
					width: '100%',
					minWidth: '600px',
					margin: 0,
					borderRadius: 12
				}}
			>
				<Box>
					<DialogTitle
						sx={{
							m: 0,
							textAlign: 'center',
							backgroundColor: theme.palette.primary.main,
							color: '#fff'
						}}
					>
						Add Event Video
					</DialogTitle>
					<IconButton
						sx={{
							position: 'absolute',
							right: 10,
							top: 8,
							color: '#fff',
							fontWeight: 'bold'
						}}
						onClick={onClose}
					>
						<Close />
					</IconButton>
				</Box>
				<Box sx={{ padding: 2 }}>
					<Grid container spacing={1} sx={{ marginBottom: 6 }}>
						<Grid item xs={12} sm={12}>
							<TextInput
								value={eventVideo.title}
								required
								label="Video Title"
								name="title"
								placeholder="Video Title"
								handleChange={handleChange}
							/>
						</Grid>
					</Grid>
					<center>
						<VideoUploader
							label="Select Video File"
							videoUrl={memoryFile?.video_url?.url}
							handleUpload={handleVideoSelect}
							handleDelete={() => handleDelete('video_url')}
						/>
					</center>
					<Grid container spacing={1} sx={{ marginBottom: 6 }}>
						<Grid item xs={12} sm={12}>
							<TextInput
								value={eventVideo.cloudinary_url}
								label="Cloudinary Video Url"
								name="cloudinary_url"
								placeholder="Cloudinary Video Url"
								handleChange={handleChange}
							/>
						</Grid>
					</Grid>

					<Grid container spacing={1} sx={{ marginBottom: 6 }}>
						<Grid item xs={12} sm={12} sx={{ textAlign: 'right' }}>
							<Button
								color="primary"
								variant="contained"
								type="submit"
								onClick={submit}
							>
								{'Add Video'}
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default VideoModal;
